import { styled, css } from '../../style';

const StyledDiv = styled('div')(
  ({ theme }) => css`
    .wallet-provider-modal {
      background-color: ${theme.colors.quickModal};
      border: ${theme.colors.cardBorder};
      border-radius: 12px;

      * {
        color: ${theme.colors.primaryText};
      }
    }

    .wallet-provider-card {
      color: #fff;
    }
  `
);

export default StyledDiv;
